firebird.controller('internationalNumbersModalCtrl', [
    '$rootScope',
    '$scope',
    '$sce',
    'helperService',
    function ($rootScope, $scope, $sce, helperService) {
        var self = this;

        self.onShowModal = onShowModal;
        self.onHideModal = onHideModal;
        self.modalState = 'closed';
        self.domain = helperService.getLocationHost();

        if (helperService.getIsRedesign() === true) {
            self.url = $sce.trustAsResourceUrl(
                'https://www.' + self.domain + '/AccountManager/PhoneInternationalNumbers.aspx?iframe=1&redesign=1'
            );
        } else {
            self.url = $sce.trustAsResourceUrl(
                'https://www.' + self.domain + '/AccountManager/PhoneInternationalNumbers.aspx?iframe=1'
            );
        }

        $rootScope.$on('show-modal', self.onShowModal);
        $rootScope.$on('hide-modal', self.onHideModal);

        ////////////////////////

        function onHideModal(e, modalName) {
            if (modalName.indexOf('internationalNumbers') !== -1) {
                self.modalState = 'closed';
                //When we close the topmost modal i.e. InternationalNumbersModal, modal-open class is removed from the body element which in turn disables the vertical scroll bar.
                //We need modal-open class present in the body as there could still be settings modal open. That's why we are adding this class back after closing the modal.
                $('body').addClass('modal-open');
                if (!helperService.getVDIRef().showContentsOnTopOfVideo) {
                    $rootScope.$broadcast('toggle-modal-on-preview', false);
                }
            }

            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function onShowModal(e, modalName) {
            if (modalName === 'internationalNumbers') {
                self.modalState = 'open';
                if (!helperService.getVDIRef().showContentsOnTopOfVideo) {
                    $rootScope.$broadcast('toggle-modal-on-preview', true);
                }
            }
        }
    }
]);
